import { useRef } from "react";
import { useLocation } from "react-router";
import goto from "src/pageDefinitions/goto";
import { trackEvent } from "src/utils/api/tracker";
import { resetSingleUseFooter } from "@components/footer/SingleUseFooter";

export function useLandingLegacyRedirect() {
  const location = useLocation();
  const retRef = useRef<boolean>(null);
  const legacyPath = location.hash.replace("#", "");

  // Note intentional, ref protected side effects in render.
  if (retRef.current === null) {
    // /survey/:questionId - Used for some previously generated links
    if (legacyPath.startsWith("/survey")) {
      resetSingleUseFooter();
      trackEvent("OnLegacyRedirect", {
        path: legacyPath,
        target: "survey",
      });

      const questionId = legacyPath.replace(/^\/survey\/?/, "");
      goto.surveyQuestion(questionId);
      retRef.current = true;
    }

    if (legacyPath === "/choosePlan") {
      resetSingleUseFooter();
      trackEvent("OnLegacyRedirect", {
        path: legacyPath,
        target: "choosePlan",
      });

      goto.choosePlan();
      retRef.current = true;
    }
  }

  return retRef.current;
}
